// constants/family.js
// Created: 2026-03-11 15:30:00 EST
// Updated: 2026-03-13 07:59:57 EDT
// Project: Giving Words to Voices
// Author: Michael Schwarz
// Version: 1.0.1
//
// Family tree constants: relation config, fate config, blank member template,
// and month names for historical date parsing.

import {
  User, Heart, Users, Baby, UserCheck, Link2,
} from 'lucide-react';

export const MONTHS = [
  'January','February','March','April','May','June',
  'July','August','September','October','November','December',
];

export const RELATION_CONFIG = {
  // ── Parents & grandparents ──────────────────────────────────
  father:          { label: 'Father',          icon: User,      color: '#3b82f6', group: 'Parents'       },
  mother:          { label: 'Mother',          icon: User,      color: '#ec4899', group: 'Parents'       },
  grandfather:     { label: 'Grandfather',     icon: User,      color: '#6366f1', group: 'Parents'       },
  grandmother:     { label: 'Grandmother',     icon: User,      color: '#a855f7', group: 'Parents'       },
  // ── Spouse ──────────────────────────────────────────────────
  spouse:          { label: 'Spouse',          icon: Heart,     color: '#f43f5e', group: 'Spouse'        },
  // ── Siblings & siblings-in-law ──────────────────────────────
  sibling:         { label: 'Sibling',         icon: Users,     color: '#8b5cf6', group: 'Siblings'      },
  brother_in_law:  { label: 'Brother-in-law',  icon: Users,     color: '#7c3aed', group: 'Siblings'      },
  sister_in_law:   { label: 'Sister-in-law',   icon: Users,     color: '#9d4edd', group: 'Siblings'      },
  // ── Children & in-laws ──────────────────────────────────────
  child:           { label: 'Child',           icon: Baby,      color: '#10b981', group: 'Children'      },
  son_in_law:      { label: 'Son-in-law',      icon: UserCheck, color: '#059669', group: 'Children'      },
  daughter_in_law: { label: 'Daughter-in-law', icon: UserCheck, color: '#34d399', group: 'Children'      },
  // ── Grandchildren ───────────────────────────────────────────
  grandchild:      { label: 'Grandchild',      icon: Baby,      color: '#f59e0b', group: 'Grandchildren' },
  grandson:        { label: 'Grandson',        icon: Baby,      color: '#f59e0b', group: 'Grandchildren' },
  granddaughter:   { label: 'Granddaughter',   icon: Baby,      color: '#fbbf24', group: 'Grandchildren' },
  // ── Extended family ─────────────────────────────────────────
  uncle:           { label: 'Uncle',           icon: User,      color: '#64748b', group: 'Extended'      },
  aunt:            { label: 'Aunt',            icon: User,      color: '#94a3b8', group: 'Extended'      },
  nephew:          { label: 'Nephew',          icon: User,      color: '#475569', group: 'Extended'      },
  niece:           { label: 'Niece',           icon: User,      color: '#64748b', group: 'Extended'      },
  cousin:          { label: 'Cousin',          icon: Users,     color: '#78716c', group: 'Extended'      },
  other:           { label: 'Other Relative',  icon: Link2,     color: '#6b7280', group: 'Extended'      },
};

export const FATE_CONFIG = {
  survived:  { label: 'Survived',        color: '#34c759', bg: '#34c75918' },
  killed:    { label: 'Murdered',        color: '#ef4444', bg: '#ef444418' },
  emigrated: { label: 'Emigrated',       color: '#3b82f6', bg: '#3b82f618' },
  postwar:   { label: 'Born after 1945', color: '#a78bfa', bg: '#a78bfa18' },
  unknown:   { label: 'Unknown',         color: '#6b7280', bg: '#6b728018' },
};

export const BLANK_MEMBER = {
  name:           '',
  name_phonetic:  '',
  relation:       'other',
  sex:            '',
  birth_year:     '',
  death_year:     '',
  birth_place:    '',
  death_place:    '',
  married_name:   '',
  fate:           'unknown',
  fate_detail:    '',
  notes:          '',
  source_locator: '',
};
